import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Signup = () => {
  const navigate = useNavigate();

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [cpassword, setCPassword] = useState('');
  const [referralCodeUsed, setReferalcode] = useState('');

  const [showPassword, setShowPassword] = useState(false);
  const [showCPassword, setShowCPassword] = useState(false);

  // WSEAQ123

  const [status, setStatus] = useState(false);

  const register = async () => {

    if (name === "") {
      toast.error("Please enter your name!");
      setStatus(false);
      return;
    }

    const emailRegex = /^[a-zA-Z0-9._%+-]+@gmail\.com$/;

    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid Gmail address!");
      setStatus(false);
      return;
    }


    if (password === "") {
      toast.error("Please enter your password!");
      setStatus(false);
      return;
    }

    const passwordRegex = /^(?=.*[A-Z])(?=.*\W).{8,}$/;
    if (!passwordRegex.test(password)) {
      toast.error("Password must be at least 8 characters long and contain at least one capital letter and one special character!");
      setStatus(false);
      return;
    }

    if (password !== cpassword) {
      toast.error("Passwords do not match!");
      setStatus(false);
      return;
    }

    const referalCodePattern = /^[A-Za-z0-9]{8}$/; // Allows uppercase, lowercase, and digits


    if (referralCodeUsed && !referalCodePattern.test(referralCodeUsed)) {
      toast.error("Please Enter a Valid 8-character Referal Code!");
      setStatus(false);
      return;
    }



    setStatus(true);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}auth/register`, { name, email, password, referralCodeUsed });
      if (response.data.status === 'error') {
        toast.warn(response.data.message);
      } else {
        setStatus(false);
        localStorage.setItem('email', email);
        toast.success(response.data.message || "Registration successful! Please check your email to activate your account.");
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      }
    } catch (err) {
      console.error('Error registering user:', err.response ? err.response.data : err.message);
      setStatus(false);
      if (err.response && err.response.status === 400) {
        toast.warn("User already exists!");
      } else {
        toast.error("Error registering the user!");
      }
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      navigate('/');
    }
  }, [navigate]);

  return (
    <div className="container-fluid Login-section">
      <div className="login-form bg-light shadow p-4 rounded">
        <h6 className="mb-3 fw-bold text-muted">
          <Icon.Person className="me-2" />
          Sign Up
        </h6>
        <div className="mb-3">
          <input type="text" onChange={(e) => setName(e.target.value)} className="form-control shadow-none" placeholder="Name" />
        </div>
        <div className="mb-3">
          <input type="email" onChange={(e) => setEmail(e.target.value)} className="form-control shadow-none" placeholder="Email" />
        </div>

        {/* Password Input */}
        <div className="mb-3 position-relative">
          <input
            type={showPassword ? 'text' : 'password'}
            onChange={(e) => setPassword(e.target.value)}
            className="form-control shadow-none"
            placeholder="Password"
          />
          {/* Toggle Password Eye Icons */}
          <Icon.EyeSlashFill
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              cursor: 'pointer',
              fontSize: '20px',
              color: '#6c757d',
            }}
            className={showPassword ? 'd-none' : ''}
          />
          <Icon.EyeFill
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              cursor: 'pointer',
              fontSize: '20px',
              color: '#6c757d',
            }}
            className={!showPassword ? 'd-none' : ''}
          />
        </div>

        {/* Confirm Password Input */}
        <div className="mb-3 position-relative">
          <input
            type={showCPassword ? 'text' : 'password'}
            onChange={(e) => setCPassword(e.target.value)}
            className="form-control shadow-none"
            placeholder="Confirm Password"
          />
          {/* Toggle Confirm Password Eye Icons */}
          <Icon.EyeSlashFill
            onClick={() => setShowCPassword(!showCPassword)}
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              cursor: 'pointer',
              fontSize: '20px',
              color: '#6c757d',
            }}
            className={showCPassword ? 'd-none' : ''}
          />
          <Icon.EyeFill
            onClick={() => setShowCPassword(!showCPassword)}
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              cursor: 'pointer',
              fontSize: '20px',
              color: '#6c757d',
            }}
            className={!showCPassword ? 'd-none' : ''}
          />
        </div>

        <div className="mb-3">
          <input type="text" onChange={(e) => setReferalcode(e.target.value)} className="form-control shadow-none" placeholder="Enter Your Referral Code" />
        </div>

        <div className="w-100 d-flex justify-content-between align-items-center mt-4">
          {status ? (
            <button className="btn btn-success w-50" disabled>
              <span className="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
              <span role="status">Signing up...</span>
            </button>
          ) : (
            <button onClick={register} className="btn btn-success w-50">
              Sign Up
            </button>
          )}
          <ToastContainer theme="dark" autoClose={2000} />
          <Link to="/login" className="nav-link">
            Login
            <Icon.BoxArrowRight className="ms-2" />
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Signup;
